import React from 'react';
import LongText from './LongText';

function formatDate (dateString, showShort = true)
{
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date)) return '';

  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  const ss = String(date.getSeconds()).padStart(2, '0');

  const dateToShow = `${yyyy}/${mm}/${dd} ${hh}:${min}:${ss}`;

  if (showShort)
  {
    return <LongText text={dateToShow} maxLength={10} withoutDots={true} />;
  } else
  {
    return dateToShow;
  }
}

export default function DateComponent ({ value, showShort = true })
{
  return <span>{formatDate(value, showShort)}</span>;
}